$(() => {
    if (document.getElementById('admin-client-invoice-form') != null) {
        $('.modal-exec').click(function(){
            $('#submission-form').submit();
        });
    }
});
